#import "../fragments/constant-contact-list.graphql"
query ConstantContactLists {
    constantContactLists {
        ...ConstantContactList
    }
}
